import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import TextLink from '../BuildingBlocks/TextLink';
import SVGIcon from '../SVGIcon';

class CollapsePanel extends Component {
  static propTypes = {
    /** Elements to be displayed inside the collapsed panel */
    children: PropTypes.node,
    /** Optional boolean to be passed if the panel should be open/closed on page load. Defaults to false */
    open: PropTypes.bool,
    /** The Text that appears beside the open SVG */
    openText: PropTypes.node,
    /** The Text that appears by the close SVG */
    closeText: PropTypes.node,
    /** The SVG to use when the drawer is open */
    openSVG: PropTypes.node,
    /** The SVG to use whenthe Drawer is closed */
    closeSVG: PropTypes.node,
    /** Adds border above text link */
    hasBorder: PropTypes.bool,
    /** Placement of the svg before or after text */
    iconPlacement: PropTypes.oneOf(['before', 'after']),
    /** Hides default margins on textlink */
    noMargins: PropTypes.bool,
    /** onClick hook */
    onClickHook: PropTypes.func
  };

  static defaultProps = {
    children: [],
    open: false,
    openText: 'Open',
    closeText: 'Close',
    openSVG: <SVGIcon selectedIcon="openPanel" />,
    closeSVG: <SVGIcon selectedIcon="closePanel" />,
    hasBorder: false,
    iconPlacement: 'before',
    noMargins: false,
    onClickHook: () => {}
  };

  constructor(props) {
    super(props);
    const { open = false } = this.props;
    this.state = { open };
    this.setOpenState = this.setOpenState.bind(this);
  }

  setOpenState() {
    const { onClickHook } = this.props;
    const { open } = this.state;
    onClickHook && onClickHook(!open);
    this.setState({ open: !open });
  }

  render() {
    const { openText, closeText, children, openSVG, closeSVG, iconPlacement, hasBorder, noMargins } = this.props;
    const { open } = this.state;
    return (
      <div>
        <Collapse in={open}>{children}</Collapse>
        <TextLink
          className="toggle-button"
          onClick={this.setOpenState}
          icon={open ? closeSVG : openSVG}
          iconPlacement={iconPlacement}
          hasBorder={hasBorder}
          noMargins={noMargins}
        >
          {open ? closeText : openText}
        </TextLink>
      </div>
    );
  }
}

export default CollapsePanel;
